//# sourceMappingURL=sitemap.mjs.map
/// <reference types="./sitemap.d.mts" />
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $automations_effects from "../../admin/effects/automations.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";

export function update(store, msg) {
  if (msg instanceof $msg.UserRequestedSitemapParse) {
    let url = msg.url;
    let _pipe = new $remote.Loading();
    let _pipe$1 = ((_capture) => {
      return $store.set_sitemap_urls(store, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $automations_effects.parse_sitemap(url));
  } else if (msg instanceof $msg.UserClearedSitemap) {
    let _pipe = new $remote.NotLoaded();
    let _pipe$1 = ((_capture) => {
      return $store.set_sitemap_urls(store, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else {
    let urls = msg.urls;
    let _pipe = urls;
    let _pipe$1 = ((_capture) => {
      return $store.set_sitemap_urls(store, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  }
}
